import React from 'react';
import {Glob as G} from "../libs/Glob.mjs";
import "./AdminIndex.css";
import AdminGroupsList from "./AdminGroupsList.mjs";
import {Nav, NavLink} from "reactstrap";
import GroupIcon from "../media/images/GroupIcon.mjs";
import UserIcon from "../media/images/UserIcon.mjs";
import AdminUsersList from "./AdminUsersList.mjs";
import TextLabel from "../controls/TextLabel.mjs";
import SettingsIcon from "../media/images/SettingsIcon.mjs";
import AdminSettings from "./AdminSettings.mjs";
import ButtonExit from "../controls/ButtonExit.mjs";

const dataKey = 'AdminAllData';

const AdminIndex = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			admin: G.userIsAdmin(),
			data: undefined,
			tab: G.getPageParam('tab')
		};
		this.uid = G.generateUid('AdminIndex')
		this.reloadAdminData = this.reloadAdminData.bind(this);
	}
	reloadAdminData() {
		G.api('admin/listAll' ).then( l => {
			G.trigger(dataKey, l );
		}).catch( err => {
			console.log(err);
		}).finally( ()=>{
			G.login();
		});
	}
	componentDidMount() {
		G.register(dataKey, l => { this.setState({ data: l }); }, this.uid);
		G.register('userLogin', ()=> {
			this.setState({ admin: G.userIsAdmin() });
		}, this.uid);
		G.register('currentPage', po => {
			if ( po?.params?.tab && po.params.tab !== this.state.tab ) this.setState({ tab: po.params.tab });
		});
		if ( ! this.state.tab ) G.setCurrentPageParam('tab','Users');
		G.trigger('pageButtons',(
			<ButtonExit exit={ ()=>{ G.gotoHomePage() } } />
		));
	}
	componentWillUnmount() {
		G.trigger('pageButtons');
		G.deregister(this.uid);
	}
	render() {
		if ( ! this.state.admin ) return '';
		if ( ! this.state.data ) setTimeout( this.reloadAdminData );
		G.setStatus('pageTitle', G.label("Admin panel"));
		return(
			<div className={"AdminIndex"} id={this.uid}>
				<Nav tabs className={"TabBar center"}>
					<NavLink
						active={this.state.tab === 'Users'}
						onClick={() => {
							G.setCurrentPageParam('tab', 'Users')
						}}
					>
						<UserIcon/>
						<span>
							<TextLabel value={"Users"}/>
						</span>
					</NavLink>
					<NavLink
						active={this.state.tab === 'Groups'}
						onClick={() => {
							G.setCurrentPageParam('tab', 'Groups')
						}}
					>
						<GroupIcon/>
						<span>
							<TextLabel value={"Groups"}/>
						</span>
					</NavLink>
					<NavLink
						active={this.state.tab === 'Settings'}
						onClick={() => {
							G.setCurrentPageParam('tab', 'Settings')
						}}
					>
						<SettingsIcon/>
						<span>
							<TextLabel value={"Settings"}/>
						</span>
					</NavLink>
				</Nav>
				<div hidden={this.state.tab !== 'Users'}>
					<AdminUsersList dataKey={dataKey} refresh={this.reloadAdminData}/>
				</div>
				<div hidden={this.state.tab !== 'Groups'}>
					<AdminGroupsList dataKey={dataKey} refresh={this.reloadAdminData}/>
				</div>
				<div hidden={this.state.tab !== 'Settings'}>
					<AdminSettings />
				</div>
			</div>
		)
	}
}

export default AdminIndex;